import { ONBOARDING_STAGES } from "@/data/onboardingData";
import { DataPointList } from "./DataPointList";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { FileText, Zap } from "lucide-react";

interface ApprovalsStepProps {
  selectedKeys: Set<string>;
  onToggle: (key: string) => void;
  onRequestMissing: () => void;
}

export function ApprovalsStep({ selectedKeys, onToggle, onRequestMissing }: ApprovalsStepProps) {
  const stage = ONBOARDING_STAGES.find(s => s.id === "approvals")!;

  const icKeys = new Set(stage.subsections?.find(s => s.label === "Interconnection")?.keys || []);
  const pmKeys = new Set(stage.subsections?.find(s => s.label === "Permitting")?.keys || []);

  const interconnectionPoints = stage.dataPoints.filter(dp => icKeys.has(dp.key));
  const permittingPoints = stage.dataPoints.filter(dp => pmKeys.has(dp.key));

  return (
    <div className="space-y-4 pb-20">
      <div className="flex items-start justify-between gap-4">
        <div className="space-y-1">
          <h2 className="text-2xl font-semibold">{stage.heading}</h2>
          <p className="text-muted-foreground">{stage.subHeading}</p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card className="overflow-hidden">
          <CardHeader className="pb-3">
            <CardTitle className="flex items-center gap-2 text-lg">
              <div className="rounded-lg bg-primary/10 p-1.5">
                <FileText className="h-4 w-4 text-primary" />
              </div>
              Permitting
            </CardTitle>
            <p className="text-sm text-muted-foreground">Required permits and review processes</p>
          </CardHeader>
          <CardContent className="p-0 h-[400px]">
            <DataPointList dataPoints={permittingPoints} selectedKeys={selectedKeys} onToggle={onToggle} onRequestMissing={onRequestMissing} />
          </CardContent>
        </Card>

        <Card className="overflow-hidden">
          <CardHeader className="pb-3">
            <CardTitle className="flex items-center gap-2 text-lg">
              <div className="rounded-lg bg-[hsl(38,92%,50%)]/10 p-1.5">
                <Zap className="h-4 w-4 text-[hsl(38,92%,50%)]" />
              </div>
              Interconnection
            </CardTitle>
            <p className="text-sm text-muted-foreground">May not be required for all project types</p>
          </CardHeader>
          <CardContent className="p-0 h-[400px]">
            <DataPointList dataPoints={interconnectionPoints} selectedKeys={selectedKeys} onToggle={onToggle} onRequestMissing={onRequestMissing} />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
